var map = {
	"./caboverde/login.jpg": 1416,
	"./canaleducacao/login.jpg": 2887,
	"./demo/login.jpg": 4064,
	"./egepi/login.jpg": 4329,
	"./encceja/login.jpg": 7570,
	"./pit/login.jpg": 3870,
	"./siape/login.jpg": 5977,
	"./tjpara/login.jpg": 9609,
	"./unisescoop/login.jpg": 8707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5486;